import(/* webpackMode: "eager" */ "/vercel/path0/app/anmeldung/page.tsx");
